import { EnvironmentInterface } from "./enviroment-interface";

export const environment: EnvironmentInterface = {
    production: false,
    HaseCloudCoreEndpoint: 'https://api.slx-dev.wvblabs.com',
    HaseCloudAppEndpoint: 'https://slx-dev.wvblabs.com',
};